<template>
    <div class="container">
            <h2>联系我们</h2>
            <el-row :gutter="20">
                <el-col :span="6"  v-for="contact in contacts" :key="contact.index">
                     <el-card class="box-card" shadow="hover">
                        <h3 class="contact-title">{{contact.title}}</h3>
                        <p class="contact-text">地址:{{contact.content}}</p>
                    </el-card>
                </el-col>
            </el-row>
            
        </div>
</template>
<script>
export default{
    data() {
        return {
            contacts: [{
                path:'',
                title: '上海研发中心',
                content: '上海市虹口区曲阳路900弄复城国际3号楼612室',
                }, {
                path:'',
                title: '无锡运营中心',
                content: '无锡市滨湖区菱湖大道228号天安智慧城A1区306室',
                }, {
                path:'',
                title: '南京医学中心',
                content: '南京市雨花台区软件大道109号4幢206室',
                },{
                path:'',
                title: '郑州办事处',
                content: '郑州市金水区黄河路金成时代广场8栋1单元709室',
                },{
                path:'',
                title: '济南办事处',
                content: '济南市历下区解放路110号正大时代广场1806室',
                },{
                path:'',
                title: '石家庄办事处',
                content: '石家庄市桥西区友谊南大街38号百度空间大厦1011室',
                }
            ],        
        };
    },
}
</script>
<style>
.box-card{
    margin-bottom: 20px;
}
.contact-title{
    background: url(../../../assets/img/site.png) no-repeat scroll 0 0 transparent;
    background-size: auto 100%;
    text-indent: 2em;
    text-align: left;
}
.contact-text{
    text-align: left;
}
</style>